module.exports = __webpack_public_path__ + "static/img/logo.0fcdb17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/largescreen/logo.png
// module id = c+E6
// module chunks = 62